import { createAuthHTTP, createAuthJWT } from '@artsman/ams-loader';

import { config } from './config';

let typeAuth;

if (config.isAuthTypeJWT()) {
  typeAuth = createAuthJWT(config.getAuthJWTLoginUrl(), config.getAuthJWTRefreshUrl());
}
else if (config.isAuthTypeHTTP()) {
  typeAuth = createAuthHTTP(config.getAuthHTTPLoginUrl());
}
else {
  throw new Error('invalid auth type!');
}

export const auth = typeAuth;